import type { RouteObject } from 'react-router-dom'
import { useRoutes, Navigate } from 'react-router-dom'
import { useEffect } from 'react'
import Home from '@/pages/Home'
import Admin from '@/pages/Admin'
import Diagnostico from '@/pages/Diagnostico'
import Admin2 from '@/pages/Admin2'
import Diagnostico2 from '@/pages/Diagnostico2'
import Home2 from '@/pages/Home2'
import Renovar from '@/pages/Renovar'
import VivenciaCliente from '@/pages/VivenciaCliente'
import RenovarAcesso from '@/pages/RenovarAcesso'
import Distribuidora from '@/pages/Distribuidora'
import RedefinirSenha from '@/pages/RedefinirSenha'
import CriarSenha from '@/pages/CriarSenha'
import Capacitacao from '@/pages/Capacitacao'
import Selecao from '@/pages/Selecao'
import InscricaoConfirmada from '@/pages/InscricaoConfirmada'
import CursoAulas from '@/pages/CursoAulas'
import CursoInscricao from '@/pages/CursoInscricao'
import CursoInscricaoForm from '@/pages/CursoInscricaoForm'
import CapacitacaoEquipe from '@/pages/CapacitacaoEquipe'
import Certificado from '@/pages/Certificado'
import CertificadoDownload from '@/pages/CertificadoDownload'
import DiagnosticoKids from '@/pages/DiagnosticoKids'
import AdminKids from '@/pages/AdminKids'
import DiagnosticoCorporativo from '@/pages/DiagnosticoCorporativo'
import Mentoria from '@/pages/Mentoria'
import CursoAromaterapiaLanding from '@/pages/CursoAromaterapiaLanding'
import CursoAromaterapiaInscricao from '@/pages/CursoAromaterapiaInscricao'
import CursoAromaterapiaAulas from '@/pages/CursoAromaterapiaAulas'
import JornadaCompartilhe from '@/pages/JornadaCompartilhe'
import Bio from '@/pages/Bio'
import Jornada12Emocoes from '@/pages/Jornada12Emocoes'
import PoliticaPrivacidade from '@/pages/PoliticaPrivacidade'

// Domínio antigo (apenas redirecionamento) e novo domínio principal do fluxo de consultoras
const OLD_CONSULTORA_DOMAIN = 'analise.reacendaluz.com.br'
// Usamos 'www' como destino porque o CNAME foi configurado apenas em www.descubraseusoleos.com.br
// (Hostgator não permite CNAME no domínio raiz). A raiz faz redirect 301 para www via cPanel.
const NEW_CONSULTORA_DOMAIN = 'www.descubraseusoleos.com.br'

// Detecta se estamos em um domínio do fluxo de consultoras (antigo ou novo)
function isConsultoraDomain() {
  const host = window.location.hostname
  return host.includes('analise') || host.includes('descubraseusoleos')
}

// Detecta se estamos no domínio antigo que precisa redirecionar
function isOldConsultoraDomain() {
  const host = window.location.hostname
  return host === OLD_CONSULTORA_DOMAIN || host === `www.${OLD_CONSULTORA_DOMAIN}`
}

// Redirect 301-like (client-side) preservando path, query string e hash
function RedirectToNewDomain() {
  useEffect(() => {
    const { pathname, search, hash } = window.location
    const newUrl = `https://${NEW_CONSULTORA_DOMAIN}${pathname}${search}${hash}`
    // Usa replace para não deixar o domínio antigo no histórico (mais próximo de 301)
    window.location.replace(newUrl)
  }, [])

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#F8F4EF',
        color: '#2D6A4F',
        fontFamily: 'DM Sans, sans-serif',
        fontSize: '16px',
        padding: '24px',
        textAlign: 'center',
      }}
    >
      Redirecionando para o novo endereço...
    </div>
  )
}

// Componentes que escolhem a versão correta baseado no domínio
function SmartHome() {
  if (isOldConsultoraDomain()) return <RedirectToNewDomain />
  return isConsultoraDomain() ? <Home2 /> : <Home />
}

function SmartDiagnostico() {
  if (isOldConsultoraDomain()) return <RedirectToNewDomain />
  return isConsultoraDomain() ? <Diagnostico2 /> : <Diagnostico />
}

function SmartAdmin() {
  if (isOldConsultoraDomain()) return <RedirectToNewDomain />
  return isConsultoraDomain() ? <Admin2 /> : <Admin />
}

// SEGURANÇA: o autocadastro público de consultoras foi desativado. A rota /cadastro
// não deve mais permitir a criação de novas contas sem autorização da administradora.
// Qualquer acesso a /cadastro é redirecionado para a página de login (/admin).
function SmartCadastro() {
  return <Navigate to="/admin" replace />
}

function SmartRenovar() {
  if (isOldConsultoraDomain()) return <RedirectToNewDomain />
  return isConsultoraDomain() ? <Renovar /> : <Home />
}

// Alias público mais intuitivo para a página de assinatura
function SmartRenovarAcesso() {
  return isConsultoraDomain() ? <RenovarAcesso /> : <Home />
}

const SmartAssinar = SmartRenovar

function SmartDistribuidora() {
  if (isOldConsultoraDomain()) return <RedirectToNewDomain />
  return isConsultoraDomain() ? <Distribuidora /> : <Home />
}

function SmartRedefinirSenha() {
  if (isOldConsultoraDomain()) return <RedirectToNewDomain />
  return isConsultoraDomain() ? <RedefinirSenha /> : <Home />
}

// Páginas do funil de capacitação (curso introdutório) — exclusivas do domínio das consultoras
function SmartCapacitacao() {
  if (isOldConsultoraDomain()) return <RedirectToNewDomain />
  return isConsultoraDomain() ? <Capacitacao /> : <Home />
}

function SmartSelecao() {
  if (isOldConsultoraDomain()) return <RedirectToNewDomain />
  return isConsultoraDomain() ? <Selecao /> : <Home />
}

// Landing da Capacitação da Equipe (/capacitacao-equipe) — página dedicada com
// formulário simples, sem funil de seleção, origem "Capacitacao Equipe".
function SmartCapacitacaoEquipe() {
  if (isOldConsultoraDomain()) return <RedirectToNewDomain />
  return isConsultoraDomain() ? <CapacitacaoEquipe /> : <Home />
}

function SmartInscricaoConfirmada() {
  if (isOldConsultoraDomain()) return <RedirectToNewDomain />
  return isConsultoraDomain() ? <InscricaoConfirmada /> : <Home />
}

// /curso = landing pública de apresentação (foco em saúde/bem-estar, sem negócio)
function SmartCurso() {
  if (isOldConsultoraDomain()) return <RedirectToNewDomain />
  return isConsultoraDomain() ? <CursoInscricao /> : <Home />
}

// /curso/inscricao = página separada com o formulário de inscrição
function SmartCursoInscricaoForm() {
  if (isOldConsultoraDomain()) return <RedirectToNewDomain />
  return isConsultoraDomain() ? <CursoInscricaoForm /> : <Home />
}

// /curso-aulas = player do curso com vídeos, quiz e certificado
function SmartCursoAulas() {
  if (isOldConsultoraDomain()) return <RedirectToNewDomain />
  return isConsultoraDomain() ? <CursoAulas /> : <Home />
}

function SmartCertificado() {
  if (isOldConsultoraDomain()) return <RedirectToNewDomain />
  return isConsultoraDomain() ? <Certificado /> : <Home />
}

// Rota pública de download direto do PDF do certificado (acessada via link de e-mail)
// Verifica email + token na URL — não exige sessão de login.
function SmartCertificadoDownload() {
  if (isOldConsultoraDomain()) return <RedirectToNewDomain />
  return isConsultoraDomain() ? <CertificadoDownload /> : <Home />
}

function SmartCursoAromaterapiaLanding() {
  if (isOldConsultoraDomain()) return <RedirectToNewDomain />
  return isConsultoraDomain() ? <CursoAromaterapiaLanding /> : <Home />
}

function SmartCursoAromaterapiaInscricao() {
  if (isOldConsultoraDomain()) return <RedirectToNewDomain />
  return isConsultoraDomain() ? <CursoAromaterapiaInscricao /> : <Home />
}

function SmartCursoAromaterapiaAulas() {
  if (isOldConsultoraDomain()) return <RedirectToNewDomain />
  return isConsultoraDomain() ? <CursoAromaterapiaAulas /> : <Home />
}

export const routes: RouteObject[] = [
  { path: '/', element: <SmartHome /> },
  { path: '/diagnostico-home', element: <Home /> },
  { path: '/resultado', element: <SmartDiagnostico /> },
  { path: '/admin', element: <SmartAdmin /> },
  { path: '/cadastro', element: <SmartCadastro /> },
  { path: '/renovar', element: <SmartRenovarAcesso /> },
  { path: '/assinar', element: <SmartAssinar /> },
  { path: '/distribuidora', element: <SmartDistribuidora /> },
  { path: '/redefinir-senha', element: <SmartRedefinirSenha /> },
  { path: '/criar-senha', element: <CriarSenha /> },
  { path: '/capacitacao', element: <SmartCapacitacao /> },
  { path: '/capacitacao-equipe', element: <SmartCapacitacaoEquipe /> },
  { path: '/selecao', element: <SmartSelecao /> },
  { path: '/inscricao-confirmada', element: <SmartInscricaoConfirmada /> },
  { path: '/curso', element: <SmartCurso /> },
  { path: '/curso/inscricao', element: <SmartCursoInscricaoForm /> },
  { path: '/curso-aulas', element: <SmartCursoAulas /> },
  { path: '/certificado', element: <SmartCertificado /> },
  { path: '/certificado/download', element: <SmartCertificadoDownload /> },
  // Diagnóstico Kids
  { path: '/kids', element: <DiagnosticoKids /> },
  { path: '/admin-kids', element: <AdminKids /> },
  // Diagnóstico Corporativo (rota pública com ?org= e ?c=)
  { path: '/corporativo', element: <DiagnosticoCorporativo /> },
  // Jornada das 12 Emoções — rota pública de acesso da cliente (token único)
  { path: '/vivencias/:token', element: <VivenciaCliente /> },
  // Jornada Compartilhe — rota pública do presente (token único, gratuita)
  { path: '/jornada-compartilhe/:token', element: <JornadaCompartilhe /> },
  // Mentoria — página pública de inscrição (com ?c= para vincular à consultora)
  { path: '/mentoria', element: <Mentoria /> },
  { path: '/bio', element: <Bio /> },
  { path: '/jornada12emocoes', element: <Jornada12Emocoes /> },
  { path: '/politica-privacidade', element: <PoliticaPrivacidade /> },
  // Cursos de Aromaterapia (5 cursos independentes)
  { path: '/cursos/:cursoId', element: <SmartCursoAromaterapiaLanding /> },
  { path: '/cursos/:cursoId/inscricao', element: <SmartCursoAromaterapiaInscricao /> },
  { path: '/cursos/:cursoId/aulas', element: <SmartCursoAromaterapiaAulas /> },
  // Rotas legadas mantidas para compatibilidade
  { path: '/resultado2', element: <Diagnostico2 /> },
  { path: '/admin2', element: <Admin2 /> },
]

function App() {
  return useRoutes(routes)
}

export default App
